import React from 'react';
import { useTaskDrawer } from '../TaskDrawerContext';
import Avatar from './Avatar';

export default function TaskFooter() {
    const { collaborators, updatingTask, handleUpdateTask, mode, handleCreateTask, task, itemType } = useTaskDrawer();

    const isMilestone = (task?.itemType === 'milestone') || (itemType === 'milestone');

    return (
        <footer className="p-4 bg-white dark:bg-[#1f1f1f] border-t border-[#e7e8e9] dark:border-[#303030] flex justify-between items-center shrink-0">
            <div className="flex -space-x-2">
                {!isMilestone && collaborators.slice(0, 5).map((collaborator) => (
                    <div key={collaborator._id || collaborator} className="ring-2 ring-white dark:ring-[#303030] flex-shrink-0 overflow-hidden" style={{ borderRadius: '50%' }}>
                        <Avatar person={collaborator} size={32} />
                    </div>
                ))}
                {!isMilestone && collaborators.length > 5 && (
                    <div className="w-8 h-8 ring-2 ring-white dark:ring-[#303030] bg-[#e7e8e9] dark:bg-[#262626] flex items-center justify-center text-xs font-bold text-[#1c1e21] dark:text-white flex-shrink-0 overflow-hidden" style={{ borderRadius: '50%' }}>
                        +{collaborators.length - 5}
                    </div>
                )}
            </div>

            <div className="flex gap-2">
                {mode === 'create' ? (
                    <button 
                        onClick={handleCreateTask} 
                        disabled={updatingTask} 
                        className="px-6 py-2 text-white rounded-lg font-bold text-sm active:scale-95 transition-transform flex items-center gap-2 shadow-sm hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed"
                        style={{ background: 'linear-gradient(90deg, #03488A 0%, #00AAF1 100%)' }}
                    >
                        <span className="material-symbols-outlined text-sm">{isMilestone ? 'diamond' : 'add'}</span>
                        {updatingTask 
                            ? (isMilestone ? 'Creating Milestone...' : 'Creating Task...') 
                            : (isMilestone ? '◆ Create Milestone' : 'Create Task')
                        }
                    </button>
                ) : (
                    <>
                        <button disabled className="px-4 py-2 text-slate-400 font-bold text-sm hover:bg-slate-100 dark:hover:bg-slate-800 rounded-lg transition-colors cursor-not-allowed opacity-40">Archive</button>
                        <button onClick={handleUpdateTask} disabled={updatingTask} className="px-6 py-2 bg-[#1c1e21] dark:bg-[#262626] dark:border dark:border-[#303030] hover:bg-black dark:hover:bg-[#303030] text-white rounded-lg font-bold text-sm active:scale-95 transition-transform">
                            {updatingTask 
                                ? (isMilestone ? 'Updating Milestone...' : 'Updating...') 
                                : (isMilestone ? 'Update Milestone' : 'Update Task')
                            }
                        </button>
                    </>
                )}
            </div>
        </footer>
    );
}
